<template>
    <div class="custom-marker">
        <svg width="54px" height="59px" viewBox="0 0 54 59" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g transform="translate(-203.000000, -1077.000000)" :fill="fillColor" :stroke="strokeColor" stroke-width="1.5">
                <path d="M230,1135 C232.437249,1135 234.796172,1129.66465 237.033143,1129.03757 C247.975612,1125.97011 256,1115.92215 256,1104 C256,1089.6406 244.359403,1078 230,1078 C215.640597,1078 204,1089.6406 204,1104 C204,1115.94328 212.052846,1126.00571 223.025043,1129.0538 C225.24472,1129.67043 227.583873,1135 230,1135 Z"></path>
            </g>
        </svg>

        <div class="inner">
            <!-- Icon -->
            <i v-if="icon" :class="[ ! label ? 'large' : null, icon ]"></i>

            <!-- Label -->
            <span class="label" v-if="label">
                {{ label }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['icon', 'label', 'fillColor', 'strokeColor'],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {},
        watch: {}
    }
</script>
